import React from 'react';
import { Pagination } from 'react-admin';

const ListPagination = props => <Pagination rowsPerPageOptions={[5, 10, 25, 50, 100]} {...props} />;

export { ListPagination };
